import { useMeQuery } from '../__generated__/me';
import { User } from '../../../__generated__/types';
import { useMemo } from 'react';
interface ReturnHook {
  me?: User | null;
}
export const useGetMe = (): ReturnHook => {
  const { data } = useMeQuery();

  const getData = useMemo<User | null>(() => {
    if (data && data.me) {
      const { name, active, email, id, is_admin } = data.me;
      return {
        name,
        active,
        email,
        id,
        is_admin
      };
    }
    return null;
  }, [data]);

  return {
    me: getData,
  };
};
